export const UNLOCK_FEATURE_DIALOG_OPEN = 'UNLOCK_FEATURE_DIALOG_OPEN'
export const UNLOCK_FEATURE_DIALOG_CLOSE = 'UNLOCK_FEATURE_DIALOG_CLOSE'

export const openUnlockFeatureDialog = () => ({ type: UNLOCK_FEATURE_DIALOG_OPEN })
export const closeUnlockFeatureDialog = () => ({ type: UNLOCK_FEATURE_DIALOG_CLOSE })
